import { useCallback } from 'react'
import { ArticleViewRequest, Permission } from 'types'
import { useAuth } from 'hooks/UseAuth'
import { redirectToLogin } from 'utils/urlUtils'
import client from 'api/client'
import { showToastMessage } from 'common/ToastMessage/ShowToastMessage'
import { showErrorMessageToast } from 'common/MessageToasts/ErrorMessageToast/ErrorMessageToast'
import { useHistory } from 'react-router-dom'
import { ErrorResponse, SuccessResponse } from 'request-dot-js'
import { capitalize } from 'lodash'

const accessMap = {
  [ArticleViewRequest.Edit]: Permission.Edit,
  [ArticleViewRequest.Comment]: Permission.Comment,
  [ArticleViewRequest.Read]: Permission.Read,
}

class ExceptionResponse {}

interface Props {
  articleKey: string
  onRequest?: (permission: Permission) => any
  onSettled?: (res: SuccessResponse<void> | ErrorResponse | ExceptionResponse) => any
}

export const useArticleViewRequestChange = ({ articleKey, onRequest, onSettled }: Props) => {
  const auth = useAuth()
  const history = useHistory()
  return useCallback(
    async (viewRequest: ArticleViewRequest) => {
      if (!auth) return redirectToLogin(history)

      const access = accessMap[viewRequest]
      onRequest?.(access)
      const res = await client.requestDocAccess(articleKey, access)
      onSettled?.(res)
      if (res.type === 'success') {
        showToastMessage(`${capitalize(access)} access request was sent! 🎉`, 'success')
      } else {
        showErrorMessageToast('There was a problem requesting access, our team has been notified.')
      }
    },
    [auth, articleKey, history, onRequest, onSettled],
  )
}
